import owd from 'owd/owd';
import '../lib/dropkick';

export default class Select extends owd.Component {
	init() {
		this.swiper = $('[data-slider="about-numbers"]').data('swiperInstance');

		let options = {
			mobile: true
		}

		this.dropkick = new Dropkick(this.$element[0], options);

		this.overrideDropkick();
		this.bind();
	}

	overrideDropkick() {
		const dkSelect = this.dropkick.select;
		const $ctx = this.$element;

		this.dropkick.select = function() {
			const res = dkSelect.apply(this, arguments);

			$ctx.trigger('dk-select');

			return res;
		}
	}

	bind() {
		this.on('dk-select', this.$element, () => {
			this.swiper.slideTo(this.dropkick.selectedIndex);
		});
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('select', {
	component: Select
});
